import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import swal from '@sweetalert/with-react'
import { Link, Redirect } from 'react-router-dom'
import moment from 'moment';
import { Modal } from "react-bootstrap";
import Select from 'react-select';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import './date-range.css'
import { Timeline, Pagination } from 'antd';

import { getCookie } from '../common_component/cookie.js';
import { useTheme } from "./theme-provider.js";
import { useAuthData } from "./auth-provider.js";
import PageError from "../common_component/PageError.js";

import StatusBadge from "../common_component/StatusBadge.js";

const statusTypeArray = ["DELIVERY_ORDER_FINALIZED", "DELIVERY_ORDER_PENDING_APPROVAL", "DELIVERY_ORDER_PUSHED", "DELIVERY_ORDER_READY_TO_SHIP", "DELIVERY_ORDER_PICKUP_SCHEDULED", "DELIVERY_ORDER_DELIVERED", "DELIVERY_ORDER_CANCELLED"]

function DeliveryOrderList() {
    const [state, setstate] = useState(2);

    const [approveOrderModalShow, setApproveOrderModalShow] = useState(false);
    const [cancelOrderModalShow, setCancelOrderModalShow] = useState(false);
    const [cancelPickupModalShow, setCancelPickupModalShow] = useState(false);
    const [pushOrderModalShow, setPushOrderModalShow] = useState(false);
    const [generateAwbModalShow, setGenerateAwbModalShow] = useState(false);
    const [shipmentPickupModalShow, setShipmentPickupModalShow] = useState(false);
    const [generateShippingLabelModalShow, setGenerateShippingLabelModalShow] = useState(false);
    const [operationType, setOperationType] = useState("");

    const daterange_picker_ref = useRef()
    const [courierPartner, setCourierPartner] = useState(null);
    const [courierPartnerList, setCourierPartnerList] = useState([]);
    const [courierCurrency, setCourierCurrency] = useState("INR");
    const [courierPartnerListApiState, setCourierPartnerListApiState] = useState(false);
    const [approveType, setApproveType] = useState("");
    const [shippingProviderType, setShippingProviderType] = useState("");
    const [deliveryOrderId, setDeliveryOrderId] = useState("");
    const [deliveryInstructions, setDeliveryInstructions] = useState([{ type: "text", description: "" }]);
    const [statusType, setStatusType] = useState({ label: "All", value: "All" });

    const [progressModalShow, setProgressModalShow] = useState(false)
    const [flowApiState, setFlowApiState] = useState(false)
    const [trackingData, setTrackingData] = useState(null);

    const [status, setstatus] = useState("");
    const [deliveryOrderList, setDeliveryOrderList] = useState([]);
    const [mainSubmitButtonState, setMainSubmitButtonState] = useState(false);

    const { theme, dropdownStyleDark } = useTheme();
    const [porterDetailsModalShow, setPorterDetailsModalShow] = useState(false);
    const [selectedPorterDetails, setSelectedPorterDetails] = useState(null);

    const [userRole, setUserRole] = useState("");
    const [allDayCheck, setAllDayCheck] = useState(true)
    const [scheduleTime, setScheduleTime] = useState(new Date().getHours() + ":" + new Date().getMinutes())
    const [scheduleDate, setScheduleDate] = useState(moment().utc().format("YYYY-MM-DD"))

    const [listCount, setListCount] = useState(0)
    const [currentPage, setCurrentPage] = useState(1)
    const [rowsPerPage, setRowsPerPage] = useState(10)
    const [searchValue, setSearchValue] = useState(null)
    const [timezone_change, set_timezone_change] = useState("+00:00");
    const [startDate, setStartDate] = useState(moment.utc().subtract(6, "days").format("YYYY-MM-DD"))
    const [endDate, setEndDate] = useState(moment.utc().format("YYYY-MM-DD"))
    const [deliveryOrderListApiState, setDeliveryOrderListApiState] = useState(false)

    const apiController = useRef(new AbortController())

    var page_name = "delivery-order-list";

    const { user, read, write, visibility, organization_id } = useAuthData(page_name);

    const loaderstyle = {
        display: "block",
        marginLeft: "auto",
        marginRight: "auto",
        marginTop: "auto",
        marginBottom: "auto",
    };


    async function getDeliveryOrderList(cp, rpp, search_v, sd, ed, st) {
        try {
            if (deliveryOrderListApiState) {
                apiController.current.abort()
                apiController.current = new AbortController()
            }
            setDeliveryOrderListApiState(true)
            const response = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/get-delivery-order-list`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "current_page": cp - 1, "rows_per_page": rpp, "search_value": search_v, "start_date": sd, "end_date": ed, "status_type": st, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const body = await response.json();

            if (body.operation !== "success") throw "get delivery order list api error"
            const response_user_info = await fetch(
                `${process.env.REACT_APP_SERVER_URL}/individual-user-info`, { method: 'POST', body: JSON.stringify({ "email": user.email, "unique_id": "", "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
            );
            const t_body = await response_user_info.json();

            let user_role = t_body.data[0].user_role;
            setUserRole(t_body.data[0].user_role)
            body.data.list.map((tempData) => {
                tempData.ApproveButtonShow = false;
                tempData.ApproveFinalButtonShow = false;

                let t1 = (tempData.approval_info)
                let t2 = tempData.add_status
                let t3 = tempData.approval_level
                if (t2 == "DELIVERY_ORDER_PENDING_APPROVAL") {
                    if (t1.type == "multilevel_approval") {

                        let tl = t1.value.find(x => x.level == (t3 == null ? 1 : t3 + 1)).user_value
                        if (tl.includes(user.email)) {
                            tempData.ApproveButtonShow = true;
                        }
                    }
                    else if (t1.type == "custom_approval") {
                        let ty = t1.value[0]
                        if (ty.user_type == "Group User") {
                            if (ty.user_value.includes(user_role)) {
                                tempData.ApproveButtonShow = true;
                            }
                        }
                        else if (ty.user_type == "Individual User") {
                            if (ty.user_value.includes(user.email)) {
                                tempData.ApproveButtonShow = true;
                            }
                        }
                    }
                    if (user_role == "Admin") {
                        tempData.ApproveFinalButtonShow = true;
                    }
                }
            })
            setDeliveryOrderList(body.data.list)
            setListCount(body.data.count)
            setDeliveryOrderListApiState(false)
        } catch (err) {
            if (err.name !== 'AbortError') {
                console.log(err)
            }
        }
    }

    async function checkCourierServiceability(order_id) {
        if (courierPartnerListApiState) {
            apiController.current.abort()
            apiController.current = new AbortController()
        }
        setCourierPartnerListApiState(true)
        const response = await fetch(
            `${process.env.REACT_APP_SERVER_URL}/check-courier-serviceability`, { signal: apiController.current.signal, method: 'POST', body: JSON.stringify({ "email": user.email, "order_id": order_id, "page_name": page_name, "organization_id": organization_id }), headers: { "Content-type": "application/json; charset=UTF-8", "token": getCookie("access_token") } }
        );
        const body = await response.json();
        setCourierPartnerListApiState(false);
        if (body.operation == "success") {
            setCourierCurrency(body.data.currency);
            setCourierPartnerList(body.data.available_courier_companies);
        }
    }

    useEffect(() => {
        if ((read || write) && (user.email && visibility)) {

            let p1 = getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value)
            Promise.all([p1])
                .then(() => {
                    setstate(1)
                    console.log("all apis done")
                })
                .catch((err) => {
                    setstate(3)
                    console.log(err)
                })
        }

    }, [user, visibility, read, write])

    useEffect(() => {
        if (state === 1) {
            getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value)
        }
    }, [currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value])

    // Custom single-value display
    const customSingleValue = ({ data }) => (
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <span>{data.label}</span>
            <span style={{ fontSize: "0.85rem", color: "#888" }}>
                {courierCurrency == "INR" && "₹"}{data.rate} | ⭐ {data.rating}
            </span>
        </div>
    );

    // Custom option layout
    const customOption = (props) => {
        const { data, innerRef, innerProps } = props;
        return (
            <div
                ref={innerRef}
                {...innerProps}
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    padding: "8px 12px",
                    cursor: "pointer",
                    backgroundColor: props.isFocused ? "#f0f0f0" : "white",
                    borderBottom: "1px solid #e6e6e6",
                }}
            >
                <div>
                    <strong>{data.label}</strong>
                </div>
                <div style={{ fontSize: "0.85rem", color: "#555" }}>
                    {courierCurrency == "INR" && "₹"}{data.rate} | ⭐ {data.rating}
                </div>
            </div>
        );
    };

    const cancelPickupDetails = () => {
        var object = {};

        object.order_id = deliveryOrderId;
        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-shipping-pickup-request`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            setCancelPickupModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", `Shipping order details cancelled successfully!`, "success").then(() => {
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const cancelOrderDetails = () => {
        var object = {};

        object.order_id = deliveryOrderId;
        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/cancel-shipping-order-details`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            setCancelOrderModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", `Shipping order details cancelled successfully!`, "success").then(() => {
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const approveOrderSubmit = (final_flag, id) => {
        var object = {};
        object.final_flag = final_flag
        object.user_role = userRole
        object.id = id
        object.user_email = user.email

        object.organization_id = organization_id
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/approve-delivery-order`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            if (res.data.operation === "success") {
                swal("Great!", `Delivery order details approved successfully!`, "success").then(() => {
                    setApproveOrderModalShow(false);
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const shipmentPickup = () => {
        var object = {};
        object.schedule_date = scheduleDate;
        object.schedule_time = scheduleTime;
        object.order_id = deliveryOrderId;
        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/request-for-shipment-pickup`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            setShipmentPickupModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", `Pickup requested successfully!`, "success").then(() => {
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const generateTrackingDetails = (delivery_order_id) => {
        var object = {};
        setFlowApiState(true);
        object.order_id = delivery_order_id;
        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/tracking-shipping-order-details`, object, headers).then((res) => {
            setMainSubmitButtonState(false);
            if (res.data.operation === "success") {
                setTrackingData(res.data.data);
                setFlowApiState(false);
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const handleDeliveryOrderAction = (delivery_order_id, operation_type) => {
        const object = {
            order_id: delivery_order_id,
            organization_id: organization_id,
            page_name: page_name
        };

        const headers = {
            headers: {
                "Content-Type": "application/json",
                Accept: "*/*",
                token: getCookie("access_token"),
            },
        };

        setMainSubmitButtonState(true);

        let endpoint = `${process.env.REACT_APP_SERVER_URL}/generate-shipment-label`;

        // Optional: use different endpoints if needed
        if (operation_type === "print_invoice") {
            endpoint = `${process.env.REACT_APP_SERVER_URL}/print-shipping-invoice`;
        }
        else if (operation_type === "generate_manifest") {
            endpoint = `${process.env.REACT_APP_SERVER_URL}/generate-shipping-manifest`;
        }
        else if (operation_type === "print_manifest") {
            endpoint = `${process.env.REACT_APP_SERVER_URL}/print-shipping-manifest`;
        }

        axios
            .post(endpoint, object, headers)
            .then((res) => {
                setMainSubmitButtonState(false);
                setGenerateShippingLabelModalShow(false);
                if (res.data.operation === "success") {
                    if (operation_type === "generate_manifest") {
                        swal("Success!", "Manifest generated successfully!", "success");
                        window.open(res.data.link, "_blank");
                    }
                    else if (["print_manifest", "print_invoice"].includes(operation_type)) {
                        // Open link in new tab for print
                        window.open(res.data.link, "_blank");
                    } else {
                        // for generate
                        window.location.href = res.data.link;
                    }
                } else if (res.data.operation === "danger") {
                    if (res.data.message === "wrong_credential") {
                        swal("Oops!", "Wrong credential!", "error");
                    } else if (res.data.message === "no_data_available") {
                        swal("Oops!", "No data available!", "error");
                    } else if (res.data.message === "Settings_not_configured") {
                        swal("Oops!", "Settings are not configured!", "error");
                    } else {
                        swal("Oops!", res.data.message, "error");
                    }
                }
            })
            .catch(function (error) {
                setMainSubmitButtonState(false);
                console.error(error);
                swal("Oops!", "Something went wrong!", "error");
            });
    };


    const generateAwbDetails = () => {
        var object = {};
        if (courierPartner == null) {
            swal("Oops!", "Courier partner need to be select", "error");
            return
        }
        object.courier_id = courierPartner.value;
        object.courier_name = courierPartner.label;
        object.order_id = deliveryOrderId;
        object.organization_id = organization_id;
        object.page_name = page_name;

        setMainSubmitButtonState(true)

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/generate-AWB-for-shipment`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            setGenerateAwbModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", `Waybill generated successfully!`, "success").then(() => {
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", res.data.message, "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    const updateStatus = (id, add_status) => {
        setDeliveryOrderId(id);
        setstatus(add_status);
        setApproveOrderModalShow(true);
    }

    const pushOrderDetails = () => {
        const currentOrder = deliveryOrderList.find(
            (x) => x.delivery_order_id === deliveryOrderId
        );

        const object = {
            order_id: deliveryOrderId,
            ...(currentOrder?.shipping_provider_type === "Porter" && {
                delivery_instructions: deliveryInstructions
            }),
            organization_id: organization_id,
            page_name: page_name
        };

        if (
            Array.isArray(deliveryInstructions) &&
            deliveryInstructions.length > 0 &&
            deliveryInstructions.some(instr => !instr.description?.trim())
        ) {
            alert("Each delivery instruction must have a non-empty description.");
            return; // Stop further execution
        }

        setMainSubmitButtonState(true);

        var headers = {
            headers: {
                "Content-Type": "application/json",
                "Accept": "*/*",
                "token": getCookie("access_token")
            }
        }
        axios.post(`${process.env.REACT_APP_SERVER_URL}/save-shipping-order-details`, object, headers).then((res) => {
            setMainSubmitButtonState(false)
            setPushOrderModalShow(false)
            if (res.data.operation === "success") {
                swal("Great!", `Shipment Creation successfully!`, "success").then(() => {
                    setPushOrderModalShow(false);
                    getDeliveryOrderList(currentPage, rowsPerPage, searchValue, startDate, endDate, statusType.value);
                })
            }
            else if (res.data.operation === "danger" && res.data.message === "wrong_credential") {
                swal("Oops!", "Wrong credential!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "no_data_available") {
                swal("Oops!", "No data available!", "error");
            }
            else if (res.data.operation === "danger" && res.data.message === "Settings_not_configured") {
                swal("Oops!", "Settings are not configured!", "error");
            }
            else {
                swal("Oops!", "Something went wrong!", "error");
            }
        })
            .catch(function (error) {
                console.log(error)
            });
    }

    // Function to render scan details in Timeline
    const renderTimelineItems = (data) => {
        //console.log(data)
        if (shippingProviderType == "Delhivery") {
            return data.Scans.map((scan, index) => (
                <Timeline.Item
                    key={index}
                    color={scan.ScanDetail.StatusCode === 'X-PNP' ? 'red' : 'green'}
                //label={new Date(scan.ScanDetail.ScanDateTime).toLocaleString()}
                >
                    <div>
                        <strong>{moment(scan.ScanDetail.ScanDateTime).format('DD MMM YYYY, hh:mm a')}</strong>
                    </div>
                    <div>{scan.ScanDetail.Instructions} at {scan.ScanDetail.ScannedLocation}</div>
                </Timeline.Item>
            ));
        }
        else {
            return data.shipment_track_activities.map((item, index) => (
                <Timeline.Item key={index} color="green">
                    <div>
                        <strong>{moment(item.date).format('DD MMM YYYY, hh:mm a')}</strong>
                    </div>
                    <div>{item.sr_status_label} at {item.location || 'Unknown Location'}</div>
                    <div>{item.activity && `Activity: ${item.activity}`}</div>
                </Timeline.Item>
            ))
        }
    };

    return (
        <>
            <div>
                <div className="d-flex flex-stack mb-5">
                    <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">Delivery Order List</h1>
                    <div className="d-flex align-items-center gap-2 gap-lg-3">
                        <Link to={`/create-delivery-order`} className="btn btn-sm btn-primary me-3 rounded btn-hover-scale">
                            <span className="d-md-none">
                                <svg width="15" height="15" viewBox="0 0 11 11" fill="none">
                                    <path d="M10.8756 6.56H6.50763V10.856H4.49163V6.56H0.123625V4.664H4.49163V0.344H6.50763V4.664H10.8756V6.56Z" fill="#fff"></path>
                                </svg>
                            </span>
                            <span className="d-none d-md-inline">Create New Order</span>
                        </Link>
                    </div>
                </div>
                <div>
                    {
                        state == 1 ?
                            <>

                                <div className="row gx-0 gap-5 m-2">
                                    <div className='col-md-3'>
                                        <DateRangePickerComponent
                                            ref={daterange_picker_ref}
                                            allowEdit={false}
                                            showClearButton={false}
                                            focus={() => { daterange_picker_ref.current.show() }}
                                            delayUpdate={true}
                                            change={(e) => {
                                                setStartDate(moment(e.startDate).format("YYYY-MM-DD"));
                                                setEndDate(moment(e.endDate).format("YYYY-MM-DD"));
                                            }}
                                            startDate={new Date(startDate)}
                                            endDate={new Date(endDate)}
                                            max={new Date().toISOString().split('T')[0]}
                                        />
                                    </div>
                                    <div className='col-md-3'>
                                        <Select
                                            options={[{ label: "All", value: "All" }, ...statusTypeArray.map(x => { return { label: x.replace("DELIVERY_ORDER", "").toLowerCase().replace(/_/g, ' ').replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()), value: x } })]}
                                            onChange={(event) => { setStatusType(event); }}
                                            value={statusType}
                                            placeholder="Select Type..."
                                            styles={theme === 'dark' ? dropdownStyleDark : {}}
                                        />
                                    </div>
                                </div>
                                <div className="card mb-5 mb-xl-8">
                                    <div className="card-header border-0 pt-5">
                                        <h3 className="card-title align-items-start flex-column">
                                            <span className="card-label fw-bold fs-3 mb-1">Delivery Orders</span>
                                            <span className="text-muted mt-1 fw-semibold fs-7">Over {deliveryOrderList.length} Orders</span>
                                        </h3>
                                        <div className="card-toolbar">
                                            <Pagination
                                                total={listCount}
                                                onChange={(page, pageSize) => {
                                                    setCurrentPage(page);
                                                    setRowsPerPage(pageSize);
                                                }}
                                                showTotal={(total, range) => `${range[0]}-${range[1]} of ${total} items`}
                                                defaultPageSize={rowsPerPage}
                                                defaultCurrent={currentPage}
                                                showSizeChanger={true}
                                            />
                                        </div>
                                    </div>
                                    <div className="card-body py-3">
                                        <div className='m-5'>
                                            <input type="text" className='form-control fw-bold border border-primary' value={searchValue} onChange={(e) => { setSearchValue(e.target.value) }} placeholder='Search Orders...' />
                                        </div>
                                        <div className="d-flex flex-column align-items-center" style={{ minHeight: "50vh" }}>
                                            <div className='overflow-auto w-100 flex-grow-1'>
                                                <table className="table table-row-bordered text-nowrap table-row-gray-100 align-middle gs-0 gy-3 h-preserve-whitespace" style={{ minWidth: "1000px" }}>
                                                    <thead>
                                                        <tr className="fw-bold text-muted">
                                                            <th className="min-w-120px">Order #</th>
                                                            <th className="min-w-120px">Order Date</th>
                                                            <th className="min-w-120px">Order Type</th>
                                                            <th className="min-w-120px">Shipping Provider</th>
                                                            <th className="min-w-120px">Invoice #</th>
                                                            <th className="min-w-120px">Challans</th>
                                                            <th className="min-w-120px">Status</th>
                                                            <th className="min-w-50px text-end">Actions</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {
                                                            deliveryOrderListApiState ?
                                                                <tr>
                                                                    <td colSpan={7} className="text-center pt-10">
                                                                        <div className="spinner-border text-primary"></div>
                                                                    </td>
                                                                </tr>
                                                                :
                                                                deliveryOrderList.length > 0 ?
                                                                    deliveryOrderList.map((obj, indx3) => {
                                                                        return (
                                                                            <tr key={indx3}>
                                                                                <td>
                                                                                    <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{obj.order_number}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="text-dark fw-bold text-hover-primary d-block mb-1 fs-6">{moment(obj.order_date).utcOffset(timezone_change).format("ll")}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="badge badge-secondary">{obj.order_type}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="badge badge-info">{obj.shipping_provider_type}</span>
                                                                                </td>
                                                                                <td>
                                                                                    <span className="badge badge-secondary">{obj.invoice_number}</span>
                                                                                </td>
                                                                                <td>
                                                                                    {obj.delivery_challan_array.slice(0, 4).map((challan, i) => (<span key={i} className={`fw-semibold badge badge-primary m-1`}>{challan.challan_number}</span>))}{obj.delivery_challan_array.length > 4 && <span className="cursor-pointer text-primary"
                                                                                    //onClick={() => setUpDrawer(obj.delivery_order_id)}
                                                                                    >...View More</span>}
                                                                                </td>
                                                                                <td>
                                                                                    <StatusBadge status={obj.add_status} entity={"DELIVERY_ORDER"} />
                                                                                </td>
                                                                                <td className="text-end">
                                                                                    <div className="dropdown">
                                                                                        <button className="btn btn-sm btn-secondary rounded" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false">
                                                                                            <i className="fas fa-bars px-0"></i>
                                                                                        </button>
                                                                                        {
                                                                                            write &&
                                                                                            <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                                                                                                {(obj.ApproveButtonShow) &&
                                                                                                    <li className="py-1"><a onClick={(e) => { setApproveType("final_approve"); updateStatus(obj.delivery_order_id, obj.add_status); }} className={`dropdown-item cursor-pointer`}>Final Approve</a></li>}
                                                                                                {(obj.ApproveFinalButtonShow) &&
                                                                                                    <li className="py-1"><a onClick={(e) => { setApproveType("approve"); updateStatus(obj.delivery_order_id, obj.add_status); }} className={`dropdown-item cursor-pointer`}>Approve</a></li>}
                                                                                                {(obj.add_status == "DELIVERY_ORDER_FINALIZED") && <li className="py-1"><a onClick={() => { setShippingProviderType(obj.shipping_provider_type); setDeliveryOrderId(obj.delivery_order_id); setPushOrderModalShow(true); }} className="dropdown-item cursor-pointer">Shipment Creation</a></li>}
                                                                                                {(obj.shipping_provider_type == "ShipRocket" && obj.add_status == "DELIVERY_ORDER_PUSHED") && <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); checkCourierServiceability(obj.delivery_order_id); setGenerateAwbModalShow(true); }} className="dropdown-item cursor-pointer">Generate AWB for Shipment</a></li>}
                                                                                                {(obj.add_status !== "DELIVERY_ORDER_CANCELLED") && <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setCancelOrderModalShow(true); }} className="dropdown-item cursor-pointer">Cancel Order</a></li>}
                                                                                                {/* {(obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") && <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setCancelPickupModalShow(true); }} className="dropdown-item cursor-pointer">Cancel Pickup</a></li>} */}
                                                                                                {obj.shipping_provider_type !== "Porter" && (obj.add_status == "DELIVERY_ORDER_READY_TO_SHIP" || obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") &&
                                                                                                    <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setOperationType("generate_shipping_label"); setGenerateShippingLabelModalShow(true); handleDeliveryOrderAction(obj.delivery_order_id, "generate_shipping_label"); }} className="dropdown-item cursor-pointer">Generate Shipping Label</a></li>}
                                                                                                {(obj.shipping_provider_type !== "Porter" && obj.add_status == "DELIVERY_ORDER_READY_TO_SHIP") && <li className="py-1"><a onClick={() => {
                                                                                                    setShippingProviderType(obj.shipping_provider_type); setDeliveryOrderId(obj.delivery_order_id); setShipmentPickupModalShow(true);
                                                                                                }} className="dropdown-item cursor-pointer">Request for Shipment Pickup</a></li>}
                                                                                                {(obj.shipping_provider_type !== "Porter" && obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") &&
                                                                                                    <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setOperationType("generate_manifest"); setGenerateShippingLabelModalShow(true); handleDeliveryOrderAction(obj.delivery_order_id, "generate_manifest"); }} className="dropdown-item cursor-pointer">Generate & Download Manifest</a></li>}
                                                                                                {(obj.shipping_provider_type !== "Porter" && obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") &&
                                                                                                    <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setOperationType("print_manifest"); setGenerateShippingLabelModalShow(true); handleDeliveryOrderAction(obj.delivery_order_id, "print_manifest"); }} className="dropdown-item cursor-pointer">Download Manifest</a></li>}
                                                                                                {obj.shipping_provider_type !== "Porter" && (obj.add_status == "DELIVERY_ORDER_READY_TO_SHIP" || obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") &&
                                                                                                    <li className="py-1"><a onClick={() => { setDeliveryOrderId(obj.delivery_order_id); setOperationType("print_invoice"); setGenerateShippingLabelModalShow(true); handleDeliveryOrderAction(obj.delivery_order_id, "print_invoice"); }} className="dropdown-item cursor-pointer">Download Invoice</a></li>}
                                                                                                {(obj.shipping_provider_type !== "Porter" && obj.add_status == "DELIVERY_ORDER_PICKUP_SCHEDULED") && <li className="py-1"><a onClick={() => {
                                                                                                    if (obj.shipping_provider_type !== "Porter") {
                                                                                                        setShippingProviderType(obj.shipping_provider_type);
                                                                                                        setDeliveryOrderId(obj.delivery_order_id);
                                                                                                        generateTrackingDetails(obj.delivery_order_id);
                                                                                                        setProgressModalShow(true);
                                                                                                    }
                                                                                                }} className="dropdown-item cursor-pointer">Generate Tracking Details</a></li>}
                                                                                                {obj.shipping_provider_type === "Porter" && obj.porter_res?.order_res &&
                                                                                                    <li className="py-1">
                                                                                                        <a
                                                                                                            onClick={() => {
                                                                                                                setSelectedPorterDetails(obj.porter_res.order_res);
                                                                                                                setPorterDetailsModalShow(true);
                                                                                                            }}
                                                                                                            className="dropdown-item cursor-pointer"
                                                                                                        >
                                                                                                            View additional Details
                                                                                                        </a>
                                                                                                    </li>
                                                                                                }

                                                                                                <li className="py-1 cursor-pointer">
                                                                                                    <Link className="dropdown-item"
                                                                                                        to={`/view-delivery-order/${obj.delivery_order_id}`}
                                                                                                    >
                                                                                                        View Details
                                                                                                    </Link>
                                                                                                </li>

                                                                                            </ul>
                                                                                        }
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        )
                                                                    })
                                                                    :
                                                                    <tr>
                                                                        <td colSpan={7} className="text-center">
                                                                            <h3 className="text-muted pt-6">No data to be shown</h3>
                                                                        </td>
                                                                    </tr>
                                                        }
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </>
                            :
                            state == 2 ?
                                <div className="card">
                                    <div className="card-body pt-6">
                                        <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                    </div>
                                </div>
                                :
                                <PageError />
                    }
                </div>
            </div>
            <Modal show={porterDetailsModalShow} onHide={() => { setPorterDetailsModalShow(false); }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Porter additional Details</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPorterDetailsModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {selectedPorterDetails && (
                        <div className="space-y-6 text-sm text-gray-700 p-4 md:p-6 bg-white rounded-lg shadow">
                            <dl className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                                {/* Pickup Time */}
                                <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                                    <dt className="text-gray-500 font-medium">Pickup Time:</dt>
                                    <dd className="font-semibold text-gray-800">
                                        {new Date(selectedPorterDetails.estimated_pickup_time).toLocaleString()}
                                    </dd>
                                </div>

                                {/* Estimated Fare (Highlighted) */}
                                <div className="flex justify-between items-center pb-2 border-b border-gray-100">
                                    <dt className="text-gray-500 font-medium">Estimated Fare:</dt>
                                    <dd className="font-extrabold text-3xl text-green-700 tracking-tight">
                                        ₹{(selectedPorterDetails.estimated_fare_details?.minor_amount / 100).toFixed(2)}
                                    </dd>
                                </div>

                                {/* Tracking URL */}
                                <div className="col-span-1 md:col-span-2 flex flex-col sm:flex-row justify-between items-start pt-2">
                                    <dt className="text-gray-500 font-medium mb-1 sm:mb-0">Tracking URL:</dt>
                                    <dd className="text-blue-600 underline break-all text-right max-w-full sm:max-w-[70%] text-sm sm:text-base">
                                        <a href={selectedPorterDetails.tracking_url} target="_blank" rel="noopener noreferrer">
                                            {selectedPorterDetails.tracking_url}
                                        </a>
                                    </dd>
                                </div>

                                {/* Delivery Instructions */}
                                {Array.isArray(selectedPorterDetails.delivery_instructions) &&
                                    selectedPorterDetails.delivery_instructions.length > 0 && (
                                        <div className="col-span-1 md:col-span-2 pt-4 border-t border-gray-100">
                                            <dt className="text-gray-500 font-medium mb-2">Delivery Instructions:</dt>
                                            <dd>
                                                <ul className="list-disc list-inside text-gray-700 max-h-32 overflow-auto p-2 border rounded bg-gray-50">
                                                    {selectedPorterDetails.delivery_instructions.map((instr, idx) => (
                                                        <li
                                                            key={idx}
                                                            className="mb-1 last:mb-0 text-sm relative before:content-['•'] before:text-blue-500 before:mr-2 before:inline-block"
                                                        >
                                                            {instr.description}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </dd>
                                        </div>
                                    )}
                            </dl>
                        </div>
                    )}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setPorterDetailsModalShow(false) }} className="btn btn-secondary">Close</button>
                </Modal.Footer>
            </Modal>
            <Modal show={progressModalShow} onHide={() => { setProgressModalShow(false); }} size="md" centered>
                <Modal.Body>
                    <div className="position-absolute top-0 end-0 p-5">
                        <div onClick={() => { setProgressModalShow(false); }} className="cursor-pointer">
                            <i className="bi bi-x-circle fs-1 text-danger"></i>
                        </div>
                    </div>
                    <div className='container mt-6'>
                        {flowApiState === true && (
                            <div className="text-center">
                                <span>Loading...</span>
                                <svg width="50" height="15" viewBox="0 45 100 10">
                                    <g transform="translate(20 50)"><circle cx="0" cy="0" r="6" fill="#e15b64"><animateTransform attributeName="transform" type="scale" begin="-0.375s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                    <g transform="translate(40 50)"><circle cx="0" cy="0" r="6" fill="#f8b26a"><animateTransform attributeName="transform" type="scale" begin="-0.25s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                    <g transform="translate(60 50)"><circle cx="0" cy="0" r="6" fill="#abbd81"><animateTransform attributeName="transform" type="scale" begin="-0.125s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                    <g transform="translate(80 50)"><circle cx="0" cy="0" r="6" fill="#81a3bd"><animateTransform attributeName="transform" type="scale" begin="0s" calcMode="spline" keySplines="0.3 0 0.7 1;0.3 0 0.7 1" values="0;1;0" keyTimes="0;0.5;1" dur="1s" repeatCount="indefinite"></animateTransform></circle></g>
                                </svg>
                            </div>
                        )}

                        {flowApiState === false && (
                            <>
                                <Timeline mode="left">
                                    {(trackingData && trackingData) && renderTimelineItems(trackingData)}
                                </Timeline>
                            </>
                        )}
                    </div>
                </Modal.Body>
            </Modal >
            <Modal show={pushOrderModalShow} onHide={() => { setPushOrderModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Shipment Creation</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setPushOrderModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    {(() => {
                        const currentOrder = deliveryOrderList.find(
                            (x) => x.delivery_order_id === deliveryOrderId
                        );

                        if (!currentOrder || currentOrder.shipping_provider_type !== "Porter") return null;

                        return (
                            <div className="form-group row mb-2">
                                <label className="col-lg-12 fs-5 fw-bold mb-2">Delivery Instructions</label>
                                <div className="col-lg-12">
                                    {deliveryInstructions.map((item, index) => (
                                        <div key={index} className="d-flex mb-2 align-items-center gap-2">
                                            <input
                                                type="text"
                                                className="form-control"
                                                value={item.description}
                                                onChange={(e) => {
                                                    const updated = [...deliveryInstructions];
                                                    updated[index].description = e.target.value;
                                                    setDeliveryInstructions(updated);
                                                }}
                                                placeholder={`Instruction ${index + 1}`}
                                            />
                                            <button
                                                type="button"
                                                className="btn btn-sm btn-icon btn-light-danger"
                                                onClick={() => {
                                                    const updated = deliveryInstructions.filter((_, i) => i !== index);
                                                    setDeliveryInstructions(updated);
                                                }}
                                            >
                                                <i className="bi bi-trash"></i>
                                            </button>
                                        </div>
                                    ))}
                                    <button
                                        type="button"
                                        className="btn btn-sm btn-primary mt-2"
                                        onClick={() =>
                                            setDeliveryInstructions([
                                                ...deliveryInstructions,
                                                { type: "text", description: "" },
                                            ])
                                        }
                                    >
                                        + Add Instruction
                                    </button>
                                </div>
                            </div>
                        );
                    })()}
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you ready for Shipment Creation?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setPushOrderModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { pushOrderDetails(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Create</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Modal show={generateAwbModalShow} onHide={() => { setGenerateAwbModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Generate AWB for Shipment</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGenerateAwbModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="row gx-0 gap-5 m-2">
                            <div className='col-md-8'>
                                <label className="fs-5 fw-bold mb-2 required">Courier Partner</label>
                                <Select
                                    options={courierPartnerList}
                                    onChange={(val) => { setCourierPartner(val); }}
                                    value={courierPartner}
                                    isLoading={courierPartnerListApiState}
                                    getOptionLabel={(e) => (
                                        <div style={{
                                            display: "flex", justifyContent: "space-between", alignItems: "center",
                                            padding: "8px 12px",
                                            cursor: "pointer",
                                            //backgroundColor: props.isFocused ? "#f0f0f0" : "white",
                                            borderBottom: "1px solid #e6e6e6"
                                        }}>
                                            <span>{e.label}</span>
                                            <span style={{ fontSize: "0.85rem", color: "#555" }}>
                                                {courierCurrency == "INR" && "₹"}{e.rate} | ⭐ {e.rating}
                                            </span>
                                        </div>
                                    )}
                                    components={{
                                        SingleValue: customSingleValue,
                                        Option: customOption,
                                    }}
                                    placeholder="Select Courier Partner"
                                    styles={{
                                        control: (provided) => ({
                                            ...provided,
                                            padding: "5px",
                                            fontSize: "1rem",
                                        }),
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-lg-12">
                            <h3>Are you sure about Generate AWB for Shipment?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setGenerateAwbModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { generateAwbDetails(e) }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Generate</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
            <Modal show={generateShippingLabelModalShow} onHide={() => { setGenerateShippingLabelModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>{operationType === "generate_manifest" && "Generate Manifest"}
                        {operationType === "print_manifest" && "Print Manifest"}
                        {operationType === "print_invoice" && "Print Invoice"}
                        {!operationType && "Generate Shipping Label"}</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setGenerateShippingLabelModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        {mainSubmitButtonState &&
                            <div className="card">
                                <div className="card-body pt-6">
                                    <img src="/images/loader-06.svg" alt="" style={loaderstyle} />
                                </div>
                            </div>
                        }
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setGenerateShippingLabelModalShow(false) }} className="btn btn-secondary">Close</button>
                </Modal.Footer>
            </Modal>
            <Modal show={shipmentPickupModalShow} onHide={() => { setShipmentPickupModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Request for Shipment Pickup</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setShipmentPickupModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="row mb-5 align-items-center">
                            <div className='col-4'>
                                <label className="fs-5 fw-bold">Pickup Date</label>
                            </div>
                            <div className="col-8">
                                <input type="date" className='form-control form-control-solid' value={scheduleDate} onChange={(e) => { setScheduleDate(e.target.value) }} min={new Date().toISOString().split("T")[0]} />
                            </div>
                        </div>

                        <div className="row mb-5 align-items-center">
                            <div className="col-6 col-md-4">
                                <label className="required fs-5 fw-bold">All Day</label>
                            </div>
                            <div className='col-6 col-md-2'>
                                <div className="form-switch">
                                    <input className="form-check-input w-45px h-30px" type="checkbox" checked={allDayCheck} onChange={(e) => { setAllDayCheck(e.target.checked) }} />
                                </div>
                            </div>
                            {
                                (!allDayCheck && shippingProviderType == "Delhivery") &&
                                <>
                                    <div className='col-3'>
                                        <input type="time" className='form-control form-control-solid' value={scheduleTime} onChange={(e) => { setScheduleTime(e.target.value) }} disabled={allDayCheck} />
                                    </div>
                                </>
                            }
                        </div>
                        <div className="col-lg-12">
                            <h3>Are you sure about Request for Shipment Pickup?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setShipmentPickupModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => { shipmentPickup(e) }} className="btn btn-primary" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Pickup</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={approveOrderModalShow} onHide={() => { setApproveOrderModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Approve Order</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setApproveOrderModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <center>
                        <div className="form-group row">
                            <div className="col-lg-12">
                                Current Status is :<StatusBadge status={status} entity={"DELIVERY_ORDER"} />
                                <br />
                                <h3 className="mt-3">Are you sure about {approveType === "final_approve" && <>& Final</>} Approve Payment?</h3>
                            </div>
                        </div>
                    </center>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setApproveOrderModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write && <form >
                        <button type="button" onClick={(e) => {
                            if (approveType === "final_approve") {
                                approveOrderSubmit(true, deliveryOrderId)
                            }
                            else {
                                approveOrderSubmit(false, deliveryOrderId)
                            }
                        }} className="btn btn-success" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState}><span className="indicator-label">{approveType === "final_approve" && <>Final </>}Approve </span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={cancelPickupModalShow} onHide={() => { setCancelPickupModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Pickup Request</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelPickupModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure about cancelling pickup request?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setCancelPickupModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write == 1 && <form >
                        <button type="button" onClick={(e) => { cancelPickupDetails(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>

            <Modal show={cancelOrderModalShow} onHide={() => { setCancelOrderModalShow() }} size="md" centered>
                <Modal.Header>
                    <Modal.Title>Cancel Order</Modal.Title>
                    <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => { setCancelOrderModalShow(false) }}>
                        <span className="svg-icon svg-icon-1">
                            <svg xmlns="http://www.w3.org/2000/svg" xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                <g transform="translate(12.000000, 12.000000) rotate(-45.000000) translate(-12.000000, -12.000000) translate(4.000000, 4.000000)" fill="#000000">
                                    <rect fill="#000000" x="0" y="7" width="16" height="2" rx="1" />
                                    <rect fill="#000000" opacity="0.5" transform="translate(8.000000, 8.000000) rotate(-270.000000) translate(-8.000000, -8.000000)" x="0" y="7" width="16" height="2" rx="1" />
                                </g>
                            </svg>
                        </span>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <div className="form-group row">
                        <div className="col-lg-12">
                            <h3>Are you sure about cancelling order?</h3>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" onClick={(e) => { setCancelOrderModalShow(false) }} className="btn btn-secondary">Close</button>
                    {write == 1 && <form >
                        <button type="button" onClick={(e) => { cancelOrderDetails(e) }} className="btn btn-danger" data-kt-indicator={mainSubmitButtonState ? "on" : "off"} disabled={mainSubmitButtonState} ><span className="indicator-label">Cancel</span>
                            <span className="indicator-progress">Please wait...
                                <span className="spinner-border spinner-border-sm align-middle ms-2"></span></span></button>
                    </form>}
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default DeliveryOrderList;